<template>
  <div class="multiWraper" v-on:click.stop >
    <div class="multiHeader" @click.stop="periodClick(0)">
      <input type="text" readonly disabled :value="value" /><van-icon style="margin-left:0.04rem;position:relative;top:0.02rem;" class="arrow" name="arrow" />
      <!-- <span class="el-date-editor__trigger el-icon" :class="dateTag" @click.stop="periodClick(1)" >X</span> -->
    </div>
    <van-popup v-model="multiListTag" position="bottom" :overlay="false" click-overlay="onCancel">
        <van-row class="multiListBtns" >
            <van-col span="4" class="cancelBtn" @click="onCancel" >取 消</van-col>
            <van-col span="4" class="cancelBtn" @click="periodClick(1)" >重 置</van-col>
            <van-col span="8" class="main-title">赠送月份</van-col>
            <van-col span="4" class="confirmBtn" @click="confirm" >确 定</van-col>
        </van-row>
        <van-row class="multiListHd" >
            <!-- <button class="el-picker-panel__icon-btn el-icon-d-arrow-left" @click="switchYear(0)" ></button> -->
            <!-- <van-col span="8" style="text-align:right;"> -->
                <van-icon name="arrow-left" @click="switchYear(0)" />
            <!-- </van-col> -->
            <!-- <van-col span="8" > -->
                <input class="multiYear" type="text" :value="currentYear" readOnly="readOnly" />
            <!-- </van-col> -->
            <!-- <van-col span="8" style="text-align:left;"> -->
                <van-icon name="arrow" @click="switchYear(1)" />
            <!-- </van-col> -->
            <!-- <button class="el-picker-panel__icon-btn el-icon-d-arrow-right" @click="switchYear(1)" ></button> -->
        </van-row>
        <van-row class="multiListItems" >
            <van-col class="multiCol" span="4" v-for="(date,index) in dateList" :key="index" ><span :class="date.disabled ? (date.class + ' disabledMonth') : (date.class+(date.tag==1?' multiListSelected':''))" @click="chooseMonth(date)">{{date.name}}</span></van-col>
        </van-row>
    </van-popup>
    <div class="overlay" v-show="multiListTag" @click="onCancel"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, Icon, Row, Col, Button, Toast } from "vant";
Vue.use(Popup)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Button);
  export default{
    name:'multiPeriod',
    props:{
      dataValue:{type:Object},
      // monthRange:{type:Array,default:() => { return ['2021-12','2020-04']}}  //测试用
      monthRange:{type:Array}
    },
    data () {
      return {
        value:'',
        dateObj:{},
        dateTag:'el-icon-date',
        currentYear:new Date().getFullYear(),
        dateList:[
          {name:'01',class:'multiListItem',tag:0,disabled:false},
          {name:'02',class:'multiListItem',tag:0,disabled:false},
          {name:'03',class:'multiListItem',tag:0,disabled:false},
          {name:'04',class:'multiListItem',tag:0,disabled:false},
          {name:'05',class:'multiListItem',tag:0,disabled:false},
          {name:'06',class:'multiListItem',tag:0,disabled:false},
          {name:'07',class:'multiListItem',tag:0,disabled:false},
          {name:'08',class:'multiListItem',tag:0,disabled:false},
          {name:'09',class:'multiListItem',tag:0,disabled:false},
          {name:'10',class:'multiListItem',tag:0,disabled:false},
          {name:'11',class:'multiListItem',tag:0,disabled:false},
          {name:'12',class:'multiListItem',tag:0,disabled:false}
        ],
        multiListTag:false
      }
    },
    watch:{
      currentYear (after,prev) {
        this.initYears(after,prev);
      },
      'monthRange':{
        handler(newValue){
          this.initDisabledMonth(newValue, this.currentYear)
        },
        deep: true,
        immediate: true
      },
      'dataValue':{
        handler(newValue){
          this.dateObj = newValue
          this.coalescingPeriods()
        },
        deep: true,
        immediate: true
      },
    },
    methods:{
      periodClick (tag) {
        if(!tag){
          this.initYears(this.currentYear);
          this.clearList();
          this.multiListTag=true;
        }
        else{
            this.value="";
            this.dateObj={};
            this.$emit("periodConfirm",this.dateObj);
            this.multiListTag=false;
        }
      },
      clearList () {
        document.body.click();
        //window.dispatchEvent(new CustomEvent('click'));
      },
      chooseMonth (obj) {
        if(obj.disabled){
          return
        }

        if(obj.tag){
          obj.tag=0;
        }
        else{
          obj.tag=1;
        }
      },
      switchYear (tag) {
        if(tag==1){
          this.currentYear++;
          this.initDisabledMonth(this.monthRange,this.currentYear);
        }
        else{
          this.currentYear--;
          this.initDisabledMonth(this.monthRange,this.currentYear);
        }
      },
      initDisabledMonth(monthRange,currentYear){
        if( !monthRange || monthRange.length == 0 || !monthRange[0] || !monthRange[1]){
          return
        }
        let startYear = parseInt(monthRange[0].split('-')[0]);
        let startMonth = parseInt(monthRange[0].split('-')[1]);
        let endtYear = parseInt(monthRange[1].split('-')[0]);
        let endtMonth = parseInt(monthRange[1].split('-')[1]);

        //开始年份大于结束年份，异常情况不处理
        if(startYear > endtYear){
          Toast({message: '开始日期大于结束日期，请重新选择！', type: 'warning'});
          return
        }
        //开始年份小于当前选择的年份 && 结束年份大于当前选择的年份，则当前全部可选
        if(startYear < currentYear && endtYear > currentYear){
          for(let i=0,len=this.dateList.length;i<len;i++){
              this.dateList[i].disabled = false;
          }
        }
        //开始年份小于当前选择的年份 && 结束年份小于当前选择的年份，则当前全部不可选
        if(startYear < currentYear && endtYear < currentYear){
          for(let i=0,len=this.dateList.length;i<len;i++){
              this.dateList[i].disabled = true;
          }
        }
        //开始年份小于当前选择的年份 && 结束年份等于当前选择的年份，则只判断结束月份
        if(startYear < currentYear && endtYear == currentYear){
          for(let i=0,len=this.dateList.length;i<len;i++){
            if(this.dateList[i].name > endtMonth){
              this.dateList[i].disabled = true;
            }else{
              this.dateList[i].disabled = false;
            }
          }
        }
        //开始年份等于当前选择的年份,结束月份等于当前选择的年份,则需要判断开始月份和结束月份
        if(startYear == currentYear && endtYear == currentYear){
          if(startMonth > endtMonth){
            Toast({message: '开始日期大于结束日期，请重新选择！', type: 'warning'});
            return
          }
          for(let i=0,len=this.dateList.length;i<len;i++){
            if(this.dateList[i].name < startMonth){
              this.dateList[i].disabled = true;
            }else if(this.dateList[i].name > endtMonth){
              this.dateList[i].disabled = true;
            }else{
              this.dateList[i].disabled = false;
            }
          }
        }
        //开始年份等于当前选择的年份,结束月份大于当前选择的年份，只需要判断开始月份
        if(startYear == currentYear && endtYear > currentYear){
          for(let i=0,len=this.dateList.length;i<len;i++){
            if(this.dateList[i].name < startMonth){
              this.dateList[i].disabled = true;
            }else{
              this.dateList[i].disabled = false;
            }
          }
        }
        //开始年份大于当前选择的年份,则全部不可选
        if(startYear > currentYear){
          for(let i=0,len=this.dateList.length;i<len;i++){
            this.dateList[i].disabled = true;
          }
        }
      },
      initYears (year,prev) {
        if(prev){
          this.dateObj[prev]=[];
          for(let i=0,len=this.dateList.length;i<len;i++){
            if(this.dateList[i].tag==1){
              this.dateObj[prev].push(this.dateList[i].name);
              this.dateList[i].tag=0;
            }
          }
        }
        else{
          for(let i=0,len=this.dateList.length;i<len;i++){
            if(this.dateList[i].tag==1){
              this.dateList[i].tag=0;
            }
          }
        }
        if(this.dateObj[year]){
          if(this.dateObj[year].length>0){
            for(let i=0,len=this.dateObj[year].length;i<len;i++){
              for(let j=0,lenJ=this.dateList.length;j<lenJ;j++){
                if(this.dateObj[year][i]==this.dateList[j].name){
                  this.dateList[j].tag=1;
                  break;
                }
              }
            }
          }
        }
        else{
          this.dateObj[year]=[];
        }
      },
      coalescingPeriods () {
        var str=[];
        for(var item in this.dateObj){
          if(this.dateObj[item].length>0){
            str.push(item+'-'+this.dateObj[item].toString());
          }
        }
        //this.dataValue=str.join(" ");
        this.value=str.join("、");
      },
      confirm () {
        this.dateObj[this.currentYear]=[];
        for(let j=0,lenJ=this.dateList.length;j<lenJ;j++){
          if(this.dateList[j].tag==1){
            this.dateObj[this.currentYear].push(this.dateList[j].name);
          }
        }
        this.coalescingPeriods();
        this.$emit("periodConfirm",this.dateObj);
        this.multiListTag=false;
      },
      onCancel() {
        this.multiListTag=false;
      },
    },
    mounted:function () {
      this.dateObj=this.dataValue;
      this.initYears(this.currentYear);
      this.coalescingPeriods();
      let This=this;
      this.initDisabledMonth(this.monthRange,this.currentYear);
      window.addEventListener( "click",function(){
        This.multiListTag=false;
      },false );
    }
  }
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1990;
}
.multiWraper{
  position:relative;
}
.multiHeader{
  position:relative;
}
.multiHeader input{
  border: none;
  text-align: right;
  line-height: 0.23rem;
  width: 88%;
  color: #516374 !important;
  font-size: 0.14rem;
  box-sizing: border-box;
  background-color: #ffffff !important;
}
.multiHeader input:disabled{
  color: #516374 !important;
}
.multiHeader input:disabled, .multiHeader input[disabled]{
  color:#516374;
  -webkit-text-fill-color:#516374;
}
.multiList{
  position:absolute;
  top:30px;
  right:0px;
  color: #475669;
  border: 1px solid #d3dce6;
  box-shadow: 0 2px 6px #ccc;
  background: #fff;
  border-radius: 2px;
  width:205px;
  z-index:1000;
}
.multiListHd{
    text-align: center;
    padding: 0.08rem 0.12rem;
    border-bottom: 1px solid #e0e0e0;
}
.multiListHd input{
  width:95px;
  text-align:center;
  font-size:14px;
  color:#475669;
  border:0px;
}
.multiListItems{
    padding: 0.12rem 0;
}
.multiCol{
    text-align: center;
}
.multiListItems span{
  display:inline-block;
  width:32px;
  height:32px;
  line-height:32px;
  text-align:center;
  border-radius:2px;
  cursor:pointer;
  margin-top:0.10rem;
}
.multiListItem{
    text-align: center;
}
.multiListSelected{
  color:#fff;
  background-color:#20a0ff;
}
.multiListItems .disabledMonth{
  color:#c2bfbf;
  background-color:#f7f7f7;
  cursor: not-allowed;
}
.multiListBtns{
  border-bottom:1px solid #e0e0e0;
  overflow: hidden;
  padding: 0.08rem 0.12rem;
}
.cancelBtn{
    color:#1fadf6;
    float: left;
    text-align: center;
}
.confirmBtn{
    color:#1fadf6;
    float: right;
    text-align: center;
}
.main-title{
    text-align: center;
    color: #1a2633;
    font-weight: bold;
}
</style>
